import { ScheduledPostTarget } from 'types'
import Styles from './IconWithStatus.module.scss'
import { ValidationResult } from '../ScheduledPostTargetPreviewItem'
import { AlertTriangle, Check2 } from 'blaze-ui/icons'
import cx from 'classnames'
import { computeStatusResult } from '../utils/getIntegrationStatus'

type Props = {
  providerIcon: React.ReactNode
  target?: ScheduledPostTarget
  validation: ValidationResult
  needsReauth: boolean
  hasMultipleIntegrations?: boolean
}

export const IconWithStatus = (props: Props) => {
  const { providerIcon, target, validation, needsReauth, hasMultipleIntegrations } = props

  // Use shared status computation logic
  const statusResult = computeStatusResult(target, needsReauth, validation)
  const showStatusIcon = !hasMultipleIntegrations && statusResult.status !== 'none'

  return (
    <div className={Styles.iconWithStatus}>
      {providerIcon}
      {showStatusIcon && (
        <div
          className={cx(Styles.alertOverlay, {
            [Styles[statusResult.overlayClass]]: statusResult.overlayClass,
          })}
        >
          {statusResult.icon === 'check' ? (
            <Check2 color={statusResult.iconColor} size={12} />
          ) : (
            <AlertTriangle color={statusResult.iconColor} size={12} />
          )}
        </div>
      )}
    </div>
  )
}
